import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

function Cookie({ bites }) {
  return (
    <svg viewBox="0 0 100 100" className="w-16 h-16 wiggle shrink-0" aria-hidden>
      <defs>
        <mask id="bite">
          <rect width="100" height="100" fill="white" />
          {bites > 0 && <circle cx="92" cy="20" r="16" fill="black" />}
          {bites > 1 && <circle cx="96" cy="46" r="13" fill="black" />}
        </mask>
      </defs>
      <g mask="url(#bite)">
        <circle cx="50" cy="50" r="44" fill="#E7B77A" stroke="#2B2A33" strokeWidth="3" />
        {[[34, 32], [60, 30], [44, 58], [68, 62], [30, 70], [55, 78]].map(([x, y], i) => (
          <circle key={i} cx={x} cy={y} r="5" fill="#6B3E26" />
        ))}
      </g>
    </svg>
  );
}

export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const [bites, setBites] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setOpen(!localStorage.getItem("mps_cookies")), 2900);
    const re = () => setOpen(true);
    window.addEventListener("mps-cookies", re);
    return () => {
      clearTimeout(t);
      window.removeEventListener("mps-cookies", re);
    };
  }, []);
  const choose = (v) => {
    setBites(2);
    localStorage.setItem("mps_cookies", v);
    setTimeout(() => setOpen(false), 450);
  };
  return (
    <AnimatePresence>
      {open && (
        <motion.div data-testid="cookie-banner" initial={{ y: 140, x: "-50%", opacity: 0 }} animate={{ y: 0, x: "-50%", opacity: 1 }} exit={{ y: 160, x: "-50%", opacity: 0 }} transition={{ type: "spring", stiffness: 160, damping: 16 }}
          className="fixed bottom-4 left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-xl z-[90] bg-white border-2 border-dashed border-[var(--pink)] sketch p-5 shadow-[0_18px_40px_-12px_rgba(212,86,140,.35)]">
          <div className="flex gap-4 items-start">
            <Cookie bites={bites} />
            <div>
              <p className="font-display text-lg">Dáte si s námi sušenku?</p>
              <p className="text-sm text-[var(--muted)] mt-1">Bez těch nezbytných by se nám rozdrobil košík. Ostatní nám jen prozradí, které materiály vás baví nejvíc. <Link to="/cookies" className="underline text-[var(--pink-dark)]">Více o sušenkách</Link></p>
            </div>
          </div>
          <div className="flex flex-wrap gap-2 mt-4 justify-center sm:justify-end">
            <button data-testid="cookie-necessary-btn" onClick={() => choose("necessary")} className="btn-ghost !py-2 !px-4" onMouseEnter={() => setBites(1)}>Jen drobečky</button>
            <button data-testid="cookie-accept-btn" onClick={() => choose("all")} className="btn-pink !py-2 !px-4" onMouseEnter={() => setBites(1)}>Mňam, beru všechny</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
